<h2 mat-dialog-title>Download MCP Configuration</h2>

<mat-dialog-content>
    <p class="dialog-description">
        Enter your workspace private key or generate a new key pair to create the MCP configuration file for Perplexity.
    </p>

    <div class="config-preview">
        <div class="config-item">
            <span class="config-label">API Key:</span>
            <span class="config-value">{{ data.apiKey | slice:0:8 }}******</span>
        </div>
        <div class="config-item">
            <span class="config-label">Base URL:</span>
            <span class="config-value">{{ data.baseUrl }}</span>
        </div>
        <div class="config-item">
            <span class="config-label">User Key:</span>
            <span class="config-value">{{ data.userKey | slice:0:8 }}******</span>
        </div>
    </div>

    <!-- Generate Key Section -->
    <div class="generate-key-section">
        <div class="section-header">
            <i class="fa-solid fa-key"></i>
            <span>Option 1: Generate New Key Pair</span>
        </div>
        <p class="section-description">
            Generate a new key pair. The public key will be registered with your workspace automatically.
        </p>
        <button mat-stroked-button color="primary" type="button" (click)="generateNewKeyPair()"
            [disabled]="isGeneratingKey" class="generate-btn">
            <i class="fa-solid" [ngClass]="isGeneratingKey ? 'fa-spinner fa-spin' : 'fa-wand-magic-sparkles'"></i>
            {{ isGeneratingKey ? 'Generating...' : 'Generate New Key Pair' }}
        </button>

        <!-- Success Message -->
        <div class="key-generation-success" *ngIf="keyGenerationSuccess">
            <i class="fa-solid fa-check-circle"></i>
            <span>Key pair generated successfully! The private key has been filled in below.</span>
            <button mat-icon-button (click)="downloadPrivateKey()" matTooltip="Download Private Key (.pem)">
                <i class="fa-solid fa-download"></i>
            </button>
        </div>

        <!-- Error Message -->
        <div class="key-generation-error" *ngIf="keyGenerationError">
            <i class="fa-solid fa-exclamation-circle"></i>
            <span>{{ keyGenerationError }}</span>
        </div>
    </div>

    <div class="divider">
        <span>OR</span>
    </div>

    <!-- Manual Key Entry Section -->
    <div class="manual-key-section">
        <div class="section-header">
            <i class="fa-solid fa-paste"></i>
            <span>Option 2: Use Existing Private Key</span>
        </div>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Private Key (PEM format)</mat-label>
            <textarea matInput [formControl]="privateKeyControl" [type]="showPrivateKey ? 'text' : 'password'" rows="6"
                placeholder="-----BEGIN EC PRIVATE KEY-----&#10;...&#10;-----END EC PRIVATE KEY-----"></textarea>
            <button mat-icon-button matSuffix type="button" (click)="togglePrivateKeyVisibility()"
                [attr.aria-label]="showPrivateKey ? 'Hide private key' : 'Show private key'">
                <i class="fa-solid" [ngClass]="showPrivateKey ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
            <mat-error *ngIf="privateKeyControl.hasError('required')">
                Private key is required
            </mat-error>
        </mat-form-field>

        <div class="file-upload-section">
            <span>Or upload your private key file:</span>
            <input type="file" accept=".pem,.key,.txt" (change)="onFileSelected($event)" #fileInput
                style="display: none" />
            <button mat-stroked-button type="button" (click)="fileInput.click()">
                <i class="fa-solid fa-upload"></i> Upload File
            </button>
        </div>
    </div>

    <div class="security-note">
        <i class="fa-solid fa-shield-halved"></i>
        <span>Your private key is only used locally to generate the config file and is not sent to any server.</span>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="privateKeyControl.invalid" (click)="downloadMcpConfig()">
        <i class="fa-solid fa-download"></i> Download Config
    </button>
</mat-dialog-actions>